import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby'
import { slugify } from 'src/utils/ug-utils';

import * as teams from 'src/uglib_utils/teams.js'
import * as styles from 'src/uglib_styles/staffDirectory.module.css'
import StaffDirectoryHeader from './staffDirectoryHeader';

function StaffDirectory ({team, subteam}) {

    const data = useStaticQuery(graphql`
        query StaffListQuery {
            collections: allNodeStaffListEntry(sort: {field_staff_last_name: ASC}) {
            edges {
                node {
                field_domain_all_affiliates
                field_staff_campus
                field_staff_email_address
                field_staff_extension
                field_staff_first_name
                field_staff_last_name
                field_staff_title
                field_staff_picture {
                    alt
                    height
                    title
                    width
                }
                field_staff_subteam
                field_staff_team
                title
                id
                path {
                    alias
                }
                relationships {
                    field_staff_picture {
                    localFile {
                        childImageSharp {
                        gatsbyImageData
                        }
                    }
                    }
                }
                }
            }
            }
        }
    `);

    const collections = data.collections.edges;
    let filtered_collections = collections;

    // Filter to the team
    if(team !== null) {
        filtered_collections = filtered_collections.filter((element) => {
            return element.node.field_staff_team === team;
        })
    }

    // Filter to the subteam
    if(subteam !== null) {
        filtered_collections = filtered_collections.filter((element) => {
            return element.node.field_staff_subteam === subteam;
        })
    }

    // Format rows
    let staff_list = filtered_collections.map((element) => {
        const staff_anchor = slugify(teams.format_name(element));
        const name = teams.format_name(element);

        return (
            <li className={"card " + styles.card} id={ staff_anchor } data-team={ element.node.field_staff_team } data-subteam={ element.node.field_staff_subteam }>
                <h3 className={styles.name}>
                    <a href={'#' + staff_anchor}>{ name }</a>
                </h3>
                <span className={styles.image_wrap}>{ teams.format_image(element) }</span>
                <span className={styles.title}> <span className="sr-only">Title: </span>{ element.node.field_staff_title }</span>
                <span className={styles.team}>
                    { teams.format_full_team(element) }
                </span>
                <span>
                    { teams.format_phone(element) }
                </span>
                <span>
                    <span className="sr-only">Email: </span>
                    <a href={"mailto:" + element.node.field_staff_email_address }>{ element.node.field_staff_email_address }</a>
                </span>
            </li>
        )
    })

    let team_name = "Library";
    if (team !== null) {
        team_name = teams.format_team(team);
    }

    if (subteam !== null) {
        team_name = teams.format_subteam(subteam);
    }

    return (<>
        <div id="staff_directory" className={styles.staff_directory}>
            <StaffDirectoryHeader />
            <h2>{team_name} Staff</h2>
            <ul id="staff_list" aria-live="polite" className={styles.staff_list}>{staff_list}</ul>
        </div>
        
    </>);
       
}

StaffDirectory.propTypes = {
	team: PropTypes.string,
    subteam: PropTypes.string
}

StaffDirectory.defaultProps = {
    team: null,
    subteam: null
}

export default StaffDirectory